var m = require('mithril');
var prop = require('mithril/stream');
var c3 = require('c3');
var moment = require('moment-timezone');
var pointChart = require('../data/components/pointChart');
var loaders = require('../layout/components/loaders');
var header = require('../layout/components/header');

var io = require('../libs/socketio');

var dateFormat = 'MMMM Do YYYY, h:mm:ss.SSSS a';

var serialize = function (obj) {
  var str = [];
  for (var p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  }
  return str.join('&');
};

var chartConfig = function(ctrl) {
  return function(vnode) {
    if (!vnode.state.chart) {
      vnode.state.chart = c3.generate({
        bindto: vnode.dom,
        data: {
          type: 'line',
          x: 'x',
          rows: [['']]
        },
        point: {
          show: false
        },
        legend: {
          show: false
        },
        axis: {
          x: {
            show: false,
            type: 'timeseries',
            tick: {
              count: 4,
              format: function (ts) { 
                var date = moment(Math.floor(ts / 1e3));
                return date.format(dateFormat);
              } 
            }
          }
        },
        // regions: [{axis: 'y', start: 1000, class: 'region-red'}]
      })
      ctrl.chart(vnode.state.chart);
      ctrl.getChart(ctrl.point);
    }
  }
};


var oninit = function () {
  var ctrl = this;
  header.vm.activeTab('Alarms');

  //ctrl.points = prop([]);
  ctrl.charts = {};
  ctrl.noData = prop(false);
  ctrl.live = prop(false);
  ctrl.loading = prop(true);
  ctrl.form = {
    start: prop(null),
    span: prop(24),
    resampling: prop('hours'),
  };

  /*ctrl.incident = loaders.requestWithLoader({
    loader: 'main',
    url: `/api/v1/incident/${m.route.param('incidentId')}`,
    method: 'GET',
  });

  var points = loaders.requestWithLoader({
    loader: 'main',
    url: `/api/v1/snapshot/${m.route.param('incidentId')}`,
    method: 'GET',
  })
    .then((results) => {
      ctrl.points(results);
      results.map((point) => {
        ctrl.charts[point['@rid']] = prop({});
      });
      return results;
    });
*/
  Promise.all([
    loaders.requestWithLoader({
      loader: 'main',
      url: `/api/v1/incident/${m.route.param('incidentId')}`,
      method: 'GET',
    }).then((results) => {
      ctrl.incident=results;
    }),
    loaders.requestWithLoader({
      loader: 'main',
      url: `/api/v1/snapshot/${m.route.param('incidentId')}`,
      method: 'GET',
    })
    .then((results) => {
      ctrl.points = results;
      results.map((point) => {
        ctrl.charts[point['@rid']] = prop({});
      });
      return results;
    })
  ])

  ctrl.download = function (evt) {
    evt.preventdefault();
    var data = {};
    data.start = ctrl.form.start();
    data.span = ctrl.form.span() + 1000;
    data.resample = ctrl.form.resampling();

    window.location = `/data/${ctrl.points['@rid']}/?${serialize(data)}`;
  };

  ctrl.getChart = function (point) {
    var inc = ctrl.incident;
    var data = {
      start: inc.timestamp + 270,
      span: 270,
      resample: 'milliseconds',
    };

    return loaders.requestWithLoader({
      loader: 'submit',
      url: `/api/v1/data/${point['@rid'].slice(1)}`,
      params: data,
      method: 'GET',
      background: true,
    })
      .then(
      // Success
        (response) => {
          loaders.submit.stop();

          if (typeof response.data === 'undefined' || response.data.length == 0) {
            ctrl.noData(true);
            ctrl.charts[point['@rid']]().load({ unload: true });
            m.redraw();
            return;
          }
          ctrl.noData(false);


    //      m.redraw();

          // Reformat data for c3
          response.data.columns[0] = 'x';
          response.data.columns[1] = `${point.name} (${point.unit})`;
          response.data.columns = response.data.columns.slice(0,2);

          // Convert Time Stamp (Someday use TZ from user profile)
          response.data.values = response.data.values.map((arr) => {
            return [arr[0], arr[1]]
            // var ts = moment.tz(arr[0], 'UTC');
            // arr[0] = ts.clone().tz('America/New_York').valueOf();
          });
          response.data.values.unshift(response.data.columns); // Remove Influx Sequence #

          // Package all that up for c3 chart.load()
          var chartData = {
            rows: response.data.values,
            type: 'spline',
            unload: [`${point.name} (${point.unit})`],
            legend: {
              show: false
            }
          };

          ctrl.charts[point['@rid']]().load(chartData);
          ctrl.charts[point['@rid']]().flush();
        },
        // Failure
        (data) => {
          loaders.submit.stop();
        }
      );
  };
};

var view = function () {
  var ctrl = this
  if(!ctrl.incident || !ctrl.points){
    return m('div')
  }

  return m('div.container', [
    m('div.nav-grid-item', [
      m('h2.pv2.bb.bw1.white', `${ctrl.incident.path[1].name} - ${ctrl.incident.name || ctrl.incident.alarm.name}`),
      m('p.white-text', `Event Time: ${moment(ctrl.incident.timestamp).format(dateFormat)}`),
    ]),
    m('div.flex.flex-wrap', [
      ctrl.points.map(function (point) {
        return m('div.w-33', [
          m('h3.bb.bw1.pv2.white', point.name),
          m('div.', { oncreate: chartConfig({ chart: ctrl.charts[point['@rid']], point: point, getChart: ctrl.getChart }) }),
          m(
            'p.text-center',
            { style: { color: '#ddd', display: ctrl.noData() ? 'block' : 'none' } },
            'No data was found for the range selected. Selecting a different range may help. If more data is needed, it may be good to reconfigure sampling for this point.'
          ),
        ])
      })
    ])
  ]);
};

module.exports = { oninit, view };
